import { useEffect, useState } from "react";
import axios from "../config/axios";
import baseURL from "../config/api";
import DOMPurify from 'dompurify';

type ShowCompleteContentProps = {
    contentId: number | null;
    onClose: () => void;
};

export const ShowCompleteContent = ({ contentId, onClose }: ShowCompleteContentProps) => {
    const [content, setContent] = useState<any>({});
    const [contentLoaded, setContentLoaded] = useState(false);

    useEffect(() => {
        if (contentId) {
            setContentLoaded(false);
            axios.get(`${baseURL}/contents/${contentId}`)
                .then((response) => {
                    const purifyResult = {
                        ...response.data,
                        lessonContent: DOMPurify.sanitize(response.data?.lessonContent, {
                            FORBID_TAGS: ['script'],
                            FORBID_ATTR: ['onerror', 'onclick', 'onload']
                        })
                    }
                    setContent(purifyResult)
                    setContentLoaded(true);
                })
                .catch((error) => console.error(error))
        }
    }, [contentId])

    return (
        <div className="bg-white p-4 rounded-md shadow-md">
            {
                (contentLoaded && content) && (
                    <>
                        <div className="flex justify-between items-center mb-3">
                            <h2 className="text-lg font-semibold">{content.title}</h2>
                            <button
                                onClick={onClose}
                                className="text-sm px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                            >
                                Close
                            </button>
                        </div>

                        <div className="sanitized-content w-full py-2 text-gray-800 whitespace-pre-wrap" dangerouslySetInnerHTML={{ __html: content?.lessonContent }} />
                    </>
                )
            }

            {
                !contentLoaded && (
                    <div className="flex items-center justify-center h-64">
                        <div className="flex flex-col items-center gap-3">
                            <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
                            <p className="text-gray-600 font-medium">Loading...</p>
                        </div>
                    </div>
                )
            }

        </div>
    )
}